export default __webpack_public_path__ + "static/media/Gallery-7.1e66a4d0.jpg";